import AcceleratorDoc from "../AcceleratorDoc";
import { MatcherFactory } from "../matchers/factory/MatcherFactory";
import { BaseField } from "./BaseField";
import { ExtractedFieldData } from "./ExtractedFieldData";

export { replaceErrorFieldsWithBlankOrReuse };

function replaceErrorFieldsWithBlankOrReuse(
  extractedFieldData: ExtractedFieldData | undefined,
  field: string,
  defaultMatcherThreshold: number,
) {
  if (!extractedFieldData) {
    return;
  }
  const extracted = extractedFieldData.getExtracted();
  // if an Extraction result exists and has a status of ERROR, don't process further
  if (
    !(
      extracted &&
      (extracted.fieldStatus === "ERROR" ||
        extracted.fieldStatus === "BLANK" ||
        !extracted.valid)
    )
  ) {
    console.log(
      `Current extraction for ${field} has valid status ${extracted?.fieldStatus}`,
    );
    return;
  }
  // replace BaseFields should not be an ERROR/BLANK/EMPTY/INVALID dlf
  const replacementReuseIndex = extractedFieldData
    .getReuse()
    .findIndex((reuse) => {
      console.log("Checking for replacement reuse value");
      console.debug(reuse);
      if (!reuse) return false;
      if (!reuse.valid) return false;

      return !(
        reuse.fieldStatus === "ERROR" ||
        reuse.fieldStatus === "BLANK" ||
        reuse.fieldStatus === "EMPTY" ||
        !reuse.valid
      );
    });

  let replacementBaseField: BaseField | undefined = undefined;
  if (replacementReuseIndex > 0) {
    console.log(
      `Found replacement reuse value from index ${replacementReuseIndex} with field Value ${extractedFieldData.getAtIndex()?.fieldValue}`,
    );
    extractedFieldData.setIndex(replacementReuseIndex);
    return;
  }
  replacementBaseField = new BaseField({
    fieldName: field,
    matcherData: MatcherFactory.defaultMatcher(field, defaultMatcherThreshold),
    fieldStatus: "BLANK",
    transformed: false,
    validationTypes: [],
    confidence: 0,
    ocrConfidence: -1,
    fieldValue: "",
    pageId: "",
    spanIds: [],
  });
  console.log(
    "Replacing extraction with " + JSON.stringify(replacementBaseField),
  );
  // overwrite failed value
  extractedFieldData.setExtracted(replacementBaseField);
}
